module.exports = __webpack_public_path__ + "img/20200613_093024.dee929ce.jpg";